<template>
  <layout-apply-cancel @cancel="cancel" @apply="applyClick" />
</template>

<script>
/** (GW)
 * Asset Editor's subtitles apply cancel (top bar)
 * Emits apply event to parent assetEditorVue
 * Dispatches changeCurrentEffect
 */

import LayoutApplyCancel from 'AssetEditor/layouts/LayoutApplyCancel.vue';
import bus from 'v/AssetEditor/AssetEditorEventBus';
import { mapActions } from 'vuex';

export default {
  components: {
    LayoutApplyCancel,
  },

  methods: {
    ...mapActions('assetEditor', ['changeCurrentPage']),

    cancel() {
      this.changeCurrentPage('preview');
    },

    /**
     * Emit apply event
     * caught by assetEditorVue's active child component
     */
    applyClick() {
      bus.$emit('apply-click');
      this.changeCurrentPage('preview');
    },
  },
};
</script>
